import axios from 'axios';
import {initActionImportLunchMeals, initFileImportUpload} from './foodilo/import';
import {initActionRestaurantGallery} from './foodilo/gallery';
import i18next from 'i18next';
import toastr from 'toastr';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initAjaxModal } from './foodilo/ajaxModal';
import {isFoodiloApp} from "./foodilo/appMode.ts";
import {PriceCalculator} from "./foodilo/PriceCalculator.ts";
import ImageCropper from './utils/imageCropper.ts';
import { fillFormFromData } from './utils/forms';
import { bindAjaxForm } from './utils/ajax';
import { quickAlert } from './utils/alerts';
import noUiSlider from 'nouislider';

initAjaxModal({
    onResponse: (resp) => {
        // Tu daj svoju pôvodnú callbackAjaxResponse logiku
        // napr. callbackAjaxResponse(resp, resp.request, textStatus, jqXHR);
        console.log('AJAX response:', resp);
    },
    // voliteľne si zmeň selektory ak máš iné ID/štruktúru
    headerSel: '#dynamic-modal-header',
    titleSel:  '#dynamic-modal-title',
    submitBtnSel: '#dynamic-modal-submit-button',
    outputSel: '#dynamic-modal-output',
    loaderSel: '#content-loader-overlay',
    formSel:   '#common-modal-form',
    modalDialogSel: '.modal-dialog',
});

window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// Mobile App detection
if (isFoodiloApp()) {
    window.axios.defaults.headers.common['X-Foodilo-App'] = '1';
    document.documentElement.classList.add('foodilo-app');
}

try {
    // Base js localization
    i18next
        .use(LanguageDetector)
        .init({
            fallbackLng: 'sk',
            debug: false,
            resources: {}, // necháme prázdne, načítame dynamicky
        }, function (err, t) {
            loadLanguage(i18next.language || 'sk');
        }).then(r => {
        console.log("i18next is initialized");
    });
    window.i18next = i18next;

    window.UI = {
        fillFormFromData,
        bindAjaxForm,
        quickAlert,
    };
}
catch (e) {
    console.log(i18next.t("Install required libraries!"));
}

function loadLanguage(lang: string | undefined) {
    fetch(`/assets/locales/${lang}.json`)
        .then(res => res.json())
        .then(data => {
            if (lang != null) {
                i18next.addResourceBundle(lang, 'translation', data, true, true);
            }
        })
        .catch(() => {
            console.error(`Nepodarilo sa načítať preklady pre jazyk: ${lang}`);
        });
}

// Spusti len ak sme na stránke s uploader (napr. podľa ID elementu)
document.addEventListener("DOMContentLoaded", () => {
    const uploader = document.getElementById('lunch-menu-import-uploader');
    if (uploader instanceof HTMLInputElement) {
        console.log('[Foodilo] ✅ Našiel som uploader, spúšťam import...');
        initFileImportUpload();
        initActionImportLunchMeals();
    }
});

window.addEventListener('reinit-selectpickers', (e) =>  {
    const componentId = e.detail?.componentId ?? null;

    function reinitSelectPickers(scope = document) {
        $(scope).find('.selectpicker').each(function () {
            $(this).selectpicker('destroy');
            $(this).selectpicker();
        });
    }

    if (componentId) {
        const el = document.querySelector(`[wire\\:id="${componentId}"]`);
        if (el) {
            reinitSelectPickers(el);
        }
    } else {
        reinitSelectPickers();
    }
});

function quick_notification(message : string, type: string = 'success') {
    if (message) {
        if (typeof type == 'undefined')
            type = 'success';

        if (type === 'success') {
            toastr.success(message);
        } else {
            toastr.error(message);
        }
    }
}

window.addEventListener('notify', (event) => {
    const detail = (event as CustomEvent).detail;

    // Livewire payload je v indexe 0
    const { message, type = 'success' } = detail[0];

    quick_notification(message, type);
});

document.addEventListener('DOMContentLoaded', () => {
    window.UI = window.UI || {};

    window.UI.imageCropper = new ImageCropper({
        previewId: 'cover-preview',
        aspectRatio: 1320 / 500,
        outputWidth: 1320,
        outputHeight: 500,
    });

    console.log('ImageCropper initialized', window.UI.imageCropper);
});

const slider = document.getElementById('cover-focal-slider');

if (slider instanceof HTMLElement) {

    const profileEl = document.getElementById('restaurant-profile');

    const restaurantPublicId = profileEl?.dataset.restaurantId;
    const initialFocalY = Number(profileEl?.dataset.cover_focal_y ?? 50);

    noUiSlider.create(slider, {
        start: Number(initialFocalY),
        orientation: 'vertical',
        direction: 'rtl',
        connect: [true, false],
        range: {
            min: 0,
            max: 100,
        },
        step: 1,
    });

    // okamžite nastav aj obrazok (bez animácie)
    const img = document.getElementById('restaurant-profile-cover-img');
    if (img) {
        img.style.objectPosition = `center ${initialFocalY}%`;
    }

    slider.noUiSlider.on('update', (values : any) => {
        const y = Math.round(values[0]);

        // IBA vizuálny posun
        const img = document.getElementById('restaurant-profile-cover-img');
        if (img) {
            img.style.objectPosition = `center ${y}%`;
        }
    });

    slider.noUiSlider.on('change', (values : any) => {
        const y = Math.round(values[0]);

        window.Livewire.dispatch('restaurant-cover-focal-updated', {
            restaurantId: restaurantPublicId,
            focalY: y,
        });
    });
}